<template>
  <div id="market" class="market">
    <!--头部用户页面内容 -->
    <div id="userInfo" class="userInfo">
      <div class="top">
        <div>
          <img class="avatar" src="../../static/img/market/icon.png" />
        </div>
        <div class="right">
          <div>
            <img
              style="width: 4.69%"
              src="../../static/img/market/member_icon.png"
              alt=""
            />
            <span style="color:rgb(255, 245, 219);" v-if="mobile != ''">{{
              mobile
            }}</span>
            <span
              @click="showLoginDialog"
              style="color:rgb(255, 245, 219);z-index: 999;pointer-events:auto;"
              v-if="mobile == ''"
              >未登录</span
            >
            <img
              style="width: 3.28%"
              src="../../static/img/market/arrow.png"
              alt=""
              @click="handleShowExitDialog"
            />
          </div>
        </div>
      </div>
      <!-- 查看我的订单 -->
      <div class="show-order" @click="handleShowOrders"></div>
    </div>

    <!--手机号码输入区域 -->
    <div id="numberInput" class="numberInput">
      <div class="input1">
        <input
          type="tel"
          v-model="mobileInput"
          maxlength="11"
          placeholder="请输入您的手机号"
        />
      </div>
    </div>

    <!--权益展示区域 -->
    <div id="rightPart" class="rightPart">
      <div class="rightBg" @click.stop="1">
        <div>
          <img
            class="movie"
            v-if="CurProductIndex == 0"
            src="../../static/img/market/movie.png"
          />
          <img
            class="movie"
            v-if="CurProductIndex != 0"
            @click="
              CurProductIndex = 0;
              CurProductArray = videoProductArray;
              CurRightIndex = 0;
              CurRightItemIndex = 0;
            "
            src="../../static/img/market/movie1.png"
          />
          <img
            class="read"
            v-if="CurProductIndex == 1"
            src="../../static/img/market/read.png"
          />
          <img
            @click="
              CurProductIndex = 1;
              CurProductArray = musicProductArray;
              CurRightIndex = 0;
              CurRightItemIndex = 0;
            "
            class="read"
            v-if="CurProductIndex != 1"
            src="../../static/img/market/read1.png"
          />
          <img
            class="life"
            v-if="CurProductIndex == 2"
            src="../../static/img/market/life.png"
          />
          <img
            class="life"
            v-if="CurProductIndex != 2"
            @click="
              CurProductIndex = 2;
              CurProductArray = lifeProductArray;
              CurRightIndex = 0;
              CurRightItemIndex = 0;
            "
            src="../../static/img/market/life1.png"
          />
          <!-- <img
            class="search"
            v-if="CurProductIndex == 3"
            src="../../static/img/market/search.png"
          />
          <img
            class="search"
            v-if="CurProductIndex != 3"
            src="../../static/img/market/search1.png"
          /> -->
        </div>

        <!-- 权益ICON展示区域 -->
        <div>
          <!-- 权益1 -->
          <div class="equity-bg" v-if="CurProductArray.length > 0">
            <div class="equity el-scrollbar__wrap">
              <el-row
                :gutter="0"
                v-for="(item, i) in CurProductArray"
                :key="item.name"
                v-if="i % 3 == 0"
              >
                <el-col :span="8">
                  <div class="grid-content">
                    <img
                      @click="
                        if (CurRightIndex != i) {
                          CurRightIndex = i;
                          CurRightItemIndex = 0;
                        }
                      "
                      class="gridimg"
                      :src="item.iconUrl"
                    />
                    <img
                      v-if="CurRightIndex == i"
                      class="gridimg"
                      :src="require(`../../static/img/market/check.png`)"
                    />
                  </div>
                </el-col>
                <el-col :span="8" v-if="i + 1 < CurProductArray.length"
                  ><div class="grid-content">
                    <img
                      @click="
                        if (CurRightIndex != i + 1) {
                          CurRightIndex = i + 1;
                          CurRightItemIndex = 0;
                        }
                      "
                      class="gridimg"
                      :src="CurProductArray[i + 1].iconUrl"
                    />
                    <img
                      v-if="CurRightIndex == i + 1"
                      class="gridimg"
                      :src="require(`../../static/img/market/check.png`)"
                    />
                  </div>
                </el-col>
                <el-col :span="8" v-if="i + 2 < CurProductArray.length"
                  ><div class="grid-content">
                    <img
                      @click="
                        if (CurRightIndex != i + 2) {
                          CurRightIndex = i + 2;
                          CurRightItemIndex = 0;
                        }
                      "
                      class="gridimg"
                      :src="CurProductArray[i + 2].iconUrl"
                    />
                    <img
                      v-if="CurRightIndex == i + 2"
                      class="gridimg"
                      :src="require(`../../static/img/market/check.png`)"
                    />
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- 权益详细数据展示区域 -->
          <div class="equityinfo-bg">
            <div class="equityinfo el-scrollbar_y_wrap">
              <ul
                style="overflow-x: auto; overflow-y: hidden;list-style: none;white-space:nowrap;width: 100%;height:100%; padding:5px;margin:0;"
              >
                <li
                  style="margin-left: 10px; display: inline-block; width: 25%;height:100%;"
                  v-for="(item, i) in CurProductArray[CurRightIndex].codeList"
                  :key="item.name"
                >
                  <div
                    class="rightItem"
                    @click="
                      if (CurRightItemIndex != i) {
                        CurRightItemIndex = i;
                      }
                    "
                  >
                    <!-- style="position: absolute; top:0%; left: 6%;font-weight:bold;letter-spacing: 1px;" -->
                    <!-- style="display: flex; flex-direction: column; magin-top:10px; align-items: center;font-weight:bold;letter-spacing: 1px;" -->
                    <div
                      style="display: flex; flex-direction: column; padding-top:2px;display: inline-block; align-items: center;font-weight:bold;letter-spacing: 1px;"
                    >
                      <span style="font-size: 12px;">{{ item.name }}</span>
                    </div>
                    <div style="position: absolute;top:25%; left: 10%;">
                      <span style="font-size: 11px;">
                        售价：<span style="color: red;"
                          >{{ item.activityPrice }}元</span
                        ></span
                      >
                    </div>
                    <div style="position: absolute;top:40%;left: 20%;">
                      <span
                        style="font-size: 9px;color: rgb(145, 144, 142);text-decoration: line-through ;"
                        >原价：{{ item.originalPrice }}元</span
                      >
                    </div>
                    <div style="position: absolute;bottom:5%;left: 6%;">
                      <span style="font-size: 9px; color:white;"
                        >{{
                          (
                            (item.activityPrice * 10) /
                            item.originalPrice
                          ).toFixed(1)
                        }}折</span
                      >
                    </div>
                    <img
                      v-if="CurRightItemIndex == i"
                      style="position: absolute; z-index: 999; width: 100%;  height: 100%;left: -2%;top: -1%;"
                      :src="
                        require(`../../static/img/market/info_kuang_check.png`)
                      "
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--点击购买区域 -->
    <div id="rightBuyPart" class="rightBuyPart">
      <div>
        <div
          style="position: absolute;top:6%; left: 5%;"
          v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
        >
          <span style="font-size: 20px;color: red;">
            ￥{{
              CurProductArray[CurRightIndex].codeList[CurRightItemIndex]
                .activityPrice
            }}</span
          >
        </div>
        <div
          style="position: absolute;top:12%; left: 22%;"
          v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
        >
          <span
            style="font-size: 12px;color: rgb(145, 144, 142);text-decoration: line-through;"
          >
            原价{{
              CurProductArray[CurRightIndex].codeList[CurRightItemIndex]
                .originalPrice
            }}</span
          >
        </div>
        <div
          style="position: absolute;top:46%; left: 5%;"
          v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
        >
          <span style="font-size: 18px;font-weight:bold;letter-spacing: 1px;">
            已选{{
              CurProductArray[CurRightIndex].codeList[CurRightItemIndex].name
            }}</span
          >
        </div>
        <div class="Buybutton" @click.stop="showComfirmDialog"></div>
      </div>
    </div>

    <!--二次确认弹框区域 -->
    <div>
      <div
        class="Dialog-wrap"
        v-if="isSHowComfirmDialog"
        @click.stop="1"
        @click="isSHowComfirmDialog = false"
      >
        <div class="ComfirmDialog" @click.stop="1">
          <div style="position: absolute;top:17%;left: 19%;">
            <span style="font-size: 18px;color: rgb(251, 122, 0);"
              >充值号码 {{ mobileInput }}</span
            >
          </div>
          <div
            style="position: absolute;top:31%; left: 6%;"
            v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
          >
            <span style="font-size: 12px;color: rgb(80, 38, 0);">
              产品名称：{{ CurProductArray[CurRightIndex].name }}-{{
                CurProductArray[CurRightIndex].codeList[CurRightItemIndex].name
              }}</span
            >
          </div>
          <div
            style="position: absolute;top:37%; left: 6%;"
            v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
          >
            <span style="font-size: 12px;color: rgb(80, 38, 0);">
              产品金额：{{
                CurProductArray[CurRightIndex].codeList[CurRightItemIndex]
                  .activityPrice
              }}元</span
            >
          </div>
          <div
            style="position: absolute;top:43%; left: 6%;"
            v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
          >
            <span style="font-size: 12px;color: rgb(80, 38, 0);">
              产品特性：{{
                CurProductArray[CurRightIndex].codeList[CurRightItemIndex]
                  .description
              }}</span
            >
          </div>
          <div
            style="position: absolute;top:55%; left: 6%;"
            v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
          >
            <span style="font-size: 12px;color: rgb(80, 38, 0);">
              到账时间：24小时内到账</span
            >
          </div>
          <div class="input2">
            <input
              type="text"
              maxlength="6"
              :value="
                `￥${CurProductArray[CurRightIndex].codeList[CurRightItemIndex].activityPrice}`
              "
              readonly="readonly"
            />
            <button
              class="button1"
              name="button"
              @click="sendCreateOrder()"
            ></button>
          </div>
          <div
            style="position: absolute;top:83%; left: 35%;"
            v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
          >
            <span style="font-size: 11px;color: rgb(80, 38, 0);">
              登录该充值号码后</span
            >
          </div>
          <div
            style="position: absolute;top:87%; left: 22%;"
            v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
          >
            <span style="font-size: 11px;color: rgb(80, 38, 0);">
              可在"查看我的订单"中查看充值进度</span
            >
          </div>
          <div
            style="position: absolute;top:91%; left: 27%;"
            v-if="CurRightIndex >= 0 && CurRightItemIndex >= 0"
          >
            <span style="font-size: 11px;color: rgb(80, 38, 0);">
              有任何疑问联系公众号蚂蚁兑哦</span
            >
          </div>
        </div>
      </div>
    </div>

    <!--//登录页面内容 -->
    <div class="login-wrap" v-if="isShowLogin">
      <div id="login" class="login" @click.stop="1">
        <div class="input1">
          <input
            type="tel"
            v-model="mobile"
            maxlength="11"
            placeholder="请输入您的手机号"
          />
        </div>
        <div class="input3">
          <input
            type="text"
            v-model="code"
            maxlength="6"
            placeholder="请输入验证码"
          />
          <button
            class="button3"
            name="button"
            @click="sendCode()"
            v-show="codeShow"
          >
            获取验证码
          </button>
          <button class="button2" name="button2" v-show="!codeShow">
            {{ count }}秒后重试
          </button>
        </div>
        <div class="submit" @click.stop="handleLogin"></div>
      </div>
    </div>

    <!-- 购买成功提示框 -->
    <div class="Dialog-wrap" v-if="isSHowPaySucDialog" @click.stop="1">
      <div class="PaySucDialog" @click.stop="1">
        <div class="okPayButton" @click.stop="handleokPayButton"></div>
      </div>
    </div>

    <!-- 购买H5提示框 -->
    <div class="Dialog-wrap" v-if="isSHowPayH5Dialog" @click.stop="1">
      <div class="PayH5Dialog" @click.stop="1">
        <div class="okPayButton" @click.stop="handleokPayButton"></div>
      </div>
    </div>

    <!-- 退出提示框 -->
    <div class="Dialog-wrap" v-if="isSHowExitDialog" @click.stop="1">
      <div class="ExitDialog" @click.stop="1">
        <div class="noexit" @click.stop="isSHowExitDialog = false"></div>
        <div class="yesexit" @click.stop="exitApp"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import md5 from "js-md5";

const request = axios.create({
  baseURL: "http://wx.threemy.com",
  timeout: 10000 //超时时间
});

const request_market = axios.create({
  baseURL: "http://120.76.216.37:9083",
  timeout: 10000 //超时时间
});

function getCurTime() {
  let nowDate = new Date();
  let date = {
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
    date: nowDate.getDate(),
    hours: nowDate.getHours(),
    minutes: nowDate.getMinutes(),
    seconds: nowDate.getSeconds()
  };
  let newmonth = date.month > 10 ? date.month : "0" + date.month;
  let newday = date.date > 10 ? date.date : "0" + date.date;
  let newminutes = date.minutes < 10 ? "0" + date.minutes : date.minutes;
  let newseconds = date.seconds < 10 ? "0" + date.seconds : date.seconds;

  let newTime =
    date.year + newmonth + newday + date.hours + newminutes + newseconds;
  return newTime;
}

request_market.interceptors.request.use(
  function(config) {
    let appSecret = "fsdljj9pnjnkfasdfjdgsaj";

    config.headers.channelCode = "mayidui";
    config.headers.timestamp = getCurTime();
    config.headers.sign = md5(
      config.headers.timestamp + config.headers.channelCode + appSecret
    );
    config.headers.version = "V1.0";
    console.log("config==" + config);
    return config;
  },
  function(erro) {
    return Promise.reject(erro);
  }
);

function getUrlKey(name) {
  //获取url 参数
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

function getCodeApi(state) {
  //获取code
  let urlNow = encodeURIComponent(window.location.href);
  let scope = "snsapi_base"; //snsapi_userinfo //静默授权 用户无感知
  let appid = "wx34adf03f5cf3870d";
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
  //alert(url);
  window.location.replace(url);
}

export default {
  inject: ["reload"],

  data() {
    return {
      mobile: "",
      mobileInput: "", //13424379612
      openid: "", //o7CK-6q2LzTvf-ohspYdAQNwzgDY
      CurProductIndex: 0,
      CurRightIndex: 0,
      CurRightItemIndex: 0,
      isSHowComfirmDialog: false,
      CurProductArray: "",
      videoProductArray: "",
      lifeProductArray: "",
      musicProductArray: "",
      isShowLogin: false,
      codeShow: true,
      code: "",
      timer: null,
      count: "",
      token: "",
      isSHowPaySucDialog: false,
      isSHowPayH5Dialog: false,
      isSHowExitDialog: false,
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight //实时屏幕高度
    };
  },
  created() {
    // let value = this.$store.getters.getStorage1;
    // if (value != null && value.openid != null) {
    //   this.openid = value.openid;
    //   //alert("openid=" + this.openid);
    // } else {
    //   let code = getUrlKey("code"); //获取url参数code
    //   //alert("code=" + code);
    //   if (code) {
    //     //拿到code， code传递给后台接口换取openid
    //     this.getOpenIdApi(code);
    //   } else {
    //     getCodeApi("12345");
    //   }
    // }
    let index = getUrlKey("index"); //获取url参数index
    if (index) {
      this.CurRightIndex = index;
    }

    let orderId = getUrlKey("orderId");
    if (orderId) {
      this.isSHowPayH5Dialog = true;
      //alert("订单购买结果请前往“查看我的订单”进行查看!");
      // request_market
      //   .get("productMarket/weixin/queryOrder", {
      //     params: {
      //       //body参数
      //       customOrderId: orderId
      //     }
      //   })
      //   .then(value => {
      //     console.log("提交计费权益接口返回内容数据：" + value);
      //     //window.location.replace(url)
      //     //调用链接跳转到微信支付页面
      //     let code = value.data.code;
      //     if (code == 0 || code == 4) {
      //       this.isSHowPaySucDialog = true;
      //     }
      //   })
      //   .catch(reason => {
      //     console.log(reason);
      //     //alert("网络请求失败，请重试!");
      //   });
    }
  },
  mounted() {
    //获取当前是否存在token值
    let value = this.$store.getters.getStorage;
    let value2 = this.$store.getters.getStorage2;
    console.log("获取本地数据: ");
    //如果本地存在token数据
    if (value != null && value.token != null) {
      this.token = value.token;
      this.mobile = value2.mobile;
      if (this.mobileInput == "") {
        this.mobileInput = value2.mobile;
      }
      console.log("本地数据: " + value.token + "--" + this.mobile);
    }
    //获取权益超市列表
    request_market
      .get("productMarket/queryAllProduct")
      .then(value => {
        console.log("提交权益超市列表接口返回内容数据：" + value);
        if (value != null) {
          this.musicProductArray = value.data.musicProductArray;
          this.lifeProductArray = value.data.lifeProductArray;
          this.videoProductArray = value.data.videoProductArray;
          this.CurProductArray = value.data.videoProductArray;
        }
      })
      .catch(reason => {
        console.log(reason);
        this.CurProductArray = value.data.videoProductArray;
        alert("网络请求失败，请重试!");
      });

    // window.onresize监听页面高度的变化
    // alert(
    //   "this.docmHeight=" +
    //     this.docmHeight +
    //     "--this.showHeight=" +
    //     this.showHeight
    // );
    window.onresize = () => {
      return (() => {
        // alert("--this.showHeight=" + this.showHeight);
        this.showHeight = document.documentElement.clientHeight;
        // alert("--this.showHeight=" + this.showHeight);
      })();
    };
  },
  //监听
  watch: {
    showHeight: function() {
      if (this.docmHeight > this.showHeight && this.isShowLogin == false) {
        document.getElementById("market").style.height = `${this.docmHeight}px`;
      } else {
        document.getElementById("market").style.height = "";
      }
    }
  },
  methods: {
    handleSetRead() {
      this.rightIndex = 1;
    },
    showComfirmDialog() {
      if (this.mobileInput == "") {
        alert("手机号码不能为空！");
        return;
      }
      //手机号码校验
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (
        this.mobileInput == "" ||
        this.mobileInput.length <= 10 ||
        !reg.test(this.mobileInput)
      ) {
        alert("请填写正确的手机号！");
        return;
      }

      if (this.CurRightIndex < 0 || this.CurRightItemIndex < 0) {
        alert("请选择相应的权益包信息！");
        return;
      }

      this.isSHowComfirmDialog = true;
    },
    getOpenIdApi(code) {
      // 通过code获取 openId等用户信息
      //alert("getOpenIdApi=" + code);
      // request
      //   .get("getopenid", {
      //     params: {
      //       //body参数
      //       code: code
      //     }
      //   })
      //   .then(value => {
      //     console.log("提交权益接口返回内容数据：" + value);
      //     //提交权益接口返回内容openid
      //     this.openid = value.data;
      //     this.$store.commit("$_setStorage1", {
      //       openid: this.openid
      //     });
      //     //alert(value);
      //   })
      //   .catch(reason => {
      //     console.log(reason);
      //     alert("网络请求失败，请重试!");
      //   });
    },
    sendCreateOrder() {
      alert("微信支付正在申请中，请稍后再试！");
      return;
      //上传openid 请求计费
      //console.log("提交数据openId=" + this.openid);
      request_market
        .get("productMarket/weixin/createH5Order", {
          params: {
            //body参数
            mobile: this.mobileInput,
            productId: this.CurProductArray[this.CurRightIndex].codeList[
              this.CurRightItemIndex
            ].id,
            // openId: this.openid,
            channelCode: "10001"
          }
        })
        .then(value => {
          console.log("提交计费权益接口返回内容数据：" + value);
          //window.location.replace(url)
          //调用链接跳转到微信支付页面
          let code = value.data.code;
          if (code == 0) {
            let payUrl = value.data.payUrl;
            let orderId = value.data.orderId;
            payUrl =
              payUrl +
              "&redirect_url=http%3A%2F%2Fwx2.threemy.com%2Fdist-market%2F%23%2Fmarket_h5%3ForderId%3D" +
              orderId;
            console.log("payUrl=" + payUrl + "--orderId=" + orderId);
            //调用计费接口
            window.location.replace(payUrl);
          } else {
            alert(value.data.msg);
          }
        })
        .catch(reason => {
          console.log(reason);
          alert("网络请求失败，请重试!");
        });
    },
    randomString(len) {
      len = len || 32;
      var $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    sendCode() {
      const TIME_COUNT = 90;
      //手机号码校验
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (
        this.mobile == "" ||
        this.mobile.length <= 10 ||
        !reg.test(this.mobile)
      ) {
        alert("请填写正确的手机号！");
        return;
      }
      //倒计时90秒开启
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      } else {
        //已经在请求中
        return;
      }
      //请求获取验证码
      request_market
        .get("/productMarket/sendSmsCode", {
          params: {
            //body参数
            mobile: this.mobile
          }
        })
        .then(value => {
          console.log(value);
          let resCode = value.data.code;
          if (resCode == 0 || resCode == 3) {
            //验证码下发成功
          } else if (resCode == 1) {
            alert("登录用户非移动用户，请重新登录!");
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          } else if (resCode == 2) {
            alert("验证码下发失败，请重新获取!");
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        })
        .catch(reason => {
          //网络请求失败 重试
          console.log(reason);
          alert("网络请求失败，请重试!");
          this.codeShow = true;
          clearInterval(this.timer);
          this.timer = null;
        });
    },
    handleLogin() {
      if (this.mobile == "") {
        alert("手机号码不能为空！");
        return;
      }

      if (this.code == "") {
        alert("验证码不能为空！");
        return;
      }

      request_market
        .get("/productMarket/loginBySmsCode", {
          params: {
            //body参数
            mobile: this.mobile,
            smscode: this.code
          }
        })
        .then(value => {
          //网络请求成功
          console.log(value);
          let code = value.data.code;
          //登录成功
          if (code == 0) {
            //获取当前用户的token值
            this.token = value.data.token;
            this.$store.commit("$_setStorage", {
              token: this.token
            });
            this.$store.commit("$_setStorage2", {
              mobile: this.mobile
            });
            this.isShowLogin = false;
            //网络请求获取当前用户的权益信息
          } else {
            //登录返回失败情况
            alert(value.data.msg);
            this.mobile = "";
            //重新获取验证码
            if (this.timer) {
              this.codeShow = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }
        })
        .catch(reason => {
          //网络请求失败
          console.log(reason);
          alert("网络请求失败，请重试!");
        });
    },
    showLoginDialog() {
      this.isShowLogin = true;
    },
    handleShowOrders() {
      //显示我的兑换页面
      if (this.token == "") {
        //未登录 则先进入登录页面
        this.isShowLogin = true;
      } else {
        let routeUrl = this.$router.resolve({
          path: "/myOrder",
          query: { token: this.token }
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    handleokPayButton() {
      this.isSHowComfirmDialog = false;
      this.isSHowPaySucDialog = false;
      this.isSHowPayH5Dialog = false;
    },
    handleShowExitDialog() {
      this.isSHowExitDialog = true;
    },
    exitApp() {
      this.mobile = "";
      this.isSHowExitDialog = false;

      this.$store.commit("$_removeStorage");
      this.$store.commit("$_removeStorage2");
      //发给后台
    }
  }
};
</script>

<style scoped>
* {
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  -webkit-appearance: none;
}

.market {
  width: 100vw;
  height: 100vh;
  background: url("../../static/img/market/background.jpg") no-repeat;
  background-size: 100% 100%;
  /* position: relative; */
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
}

.userInfo {
  position: absolute;
  width: 100%;
  height: 21.65%;
  top: 0%;
  left: 0%;
  z-index: -1;
  /* background-color: rgba(0, 0, 0, 0.6); */
}

.top {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
  font-size: 14px;
}

.avatar {
  position: absolute;
  width: 16%;
  top: 17.48%;
  left: 10.47%;
  margin-right: 5px;
}

.right {
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  top: 31.71%;
  left: 27.81%;
}

.show-order {
  position: absolute;
  width: 27.81%;
  height: 16.67%;
  left: 66%;
  top: 14%;
  background: url("../../static/img/market/littleicon.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 40px;
  background-color: none;
  overflow: hidden;
}

.numberInput {
  position: absolute;
  width: 100%;
  height: 8.45%;
  top: 21.65%;
  left: 0%;
  z-index: -1;
  /* background-color: rgba(0, 0, 0, 0.6); */
}

.numberInput .input1 {
  width: 70%;
  height: 50%;
  position: absolute;
  left: 14%;
  top: 25%;
}

.input1 input {
  width: 95%;
  border-style: none;
  height: 95%;
  background-color: rgb(255, 251, 240);
  border-radius: 12px;
  padding-left: 15px;
  outline: none;
  border: 2px solid rgb(215, 154, 4);
  font-size: 17px;
}

.input1 input::placeholder {
  color: rgb(175, 170, 170);
  font-size: 17px;
}

.rightPart {
  position: absolute;
  width: 100%;
  height: 62.76%;
  top: 30.1%;
  left: 0%;
  z-index: -1;
  /* background-color: rgba(0, 0, 0, 0.6); */
}

.rightBg {
  position: absolute;
  z-index: 999;
  width: 92.65%;
  height: 98.74%;
  /* height: 0;
  padding-bottom: 101%; */
  top: 0%;
  left: 3.67%;
  background: url("../../static/img/market/right_bg.png") no-repeat;
  background-size: 100% 100%;
}

.movie {
  position: absolute;
  width: 24.375%;
  top: 7.56%;
  left: 1.7%;
}

.read {
  position: absolute;
  width: 24.375%;
  top: 19.33%;
  left: 1.7%;
}

.life {
  position: absolute;
  width: 24.375%;
  top: 31.09%;
  left: 1.7%;
}

.search {
  position: absolute;
  width: 24.375%;
  top: 42.86%;
  left: 1.7%;
}

.equity-bg {
  position: absolute;
  z-index: 999;
  width: 69.65%;
  height: 60.94%;
  /* height: 0;
  padding-bottom: 48.9%; */
  top: 0%;
  left: 27%;
  /* background-color: rgb(250, 217, 164); */
  background-size: 100% 100%;
  /* border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px; */
}

.el-row {
  height: 25%;
  margin-top: 5px;
  margin-bottom: 25px;
  &:last-child {
    margin-bottom: 0;
  }
}

/* .el-row {
  height: 20%;
  margin-top: 5px;
  margin-bottom: 40px;
  &:last-child {
    margin-bottom: 0;
  }
} */

.el-col {
  border-radius: 4px;
}

.equity {
  position: absolute;
  z-index: 999;
  width: 100%;
  /* height: 97%;
  top: 2%; */
  height: 95%;
  top: 4%;
  overflow: auto;
  /* background-color: rgba(0, 0, 0, 0.6); */
}

.el-scrollbar__wrap {
  overflow-x: hidden;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
  margin-left: 5px;
}

.gridimg {
  position: absolute;
  z-index: 999;
  width: 32%;
  height: 100%;
}

/* .gridimg {
  position: absolute;
  z-index: 999;
  width: 36%;
  height: 124%;
} */

.check {
  border-radius: 10px;
  border: 2px solid rgb(255, 255, 212);
}

.equityinfo-bg {
  position: absolute;
  z-index: 999;
  width: 96%;
  height: 19.6%;
  top: 65%;
  left: 2%;
  /* background-color: rgba(0, 0, 0, 0.6); */
  background-size: 100% 100%;
}

.equityinfo {
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 100%;
  top: 3%;
  overflow: auto;
  /* background-color: rgba(0, 0, 0, 0.6); */
}

.el-scrollbar_y_wrap {
  overflow-y: hidden;
}

.rightItem {
  position: absolute;
  z-index: 999;
  width: 25%;
  height: 76.81%;
  background: url("../../static/img/market/info_kuang.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
}

.rightBuyPart {
  position: absolute;
  width: 100%;
  height: 7.14%;
  top: 92.86%;
  left: 0%;
  z-index: -1;
  /* background-color: rgba(0, 0, 0, 0.6); */
}

.Buybutton {
  position: absolute;
  width: 30.16%;
  /* height: 75.31%; */
  height: 0;
  padding-bottom: 9.53%;
  top: 12%;
  left: 65%;
  background: url("../../static/img/market/button1.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 40px;
  background-color: none;
  overflow: hidden;
}

.Buybutton:active {
  background: url("../../static/img/market/button1_press.png") no-repeat;
  background-size: 100% 100%;
}

.Dialog-wrap {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
}

.ComfirmDialog {
  position: absolute;
  z-index: 999;
  width: 81.56%;
  height: 0;
  padding-bottom: 92.966%;
  top: 25%;
  left: 9%;
  background: url("../../static/img/market/comfirm_bg.png") no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.input2 {
  width: 78.16%;
  height: 8.74%;
  position: absolute;
  left: 11%;
  top: 70.756%;
}

.input2 input {
  width: 90%;
  border-style: none;
  height: 100%;
  background-color: rgb(255, 251, 240);
  border-radius: 15px;
  padding-left: 15px;
  outline: none;
  border: 2px solid rgb(255, 178, 62);
  font-size: 19px;
  color: rgb(80, 38, 0);
}

.button1 {
  position: absolute;
  width: 28.676%;
  /* height: 66%; */
  height: 0;
  padding-bottom: 8.333%;
  left: 67%;
  top: 28%;
  background: url("../../static/img/market/buy_btn.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 10px;
  overflow: hidden;
  background-color: none;
  border-style: none;
  font-size: 13px;
  vertical-align: middle;
  color: rgb(255, 255, 255);
}

.button1:active {
  background: url("../../static/img/market/buy_btn_press.png") no-repeat;
  background-size: 100% 100%;
}

.login-wrap {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 888;
}

.login {
  position: absolute;
  z-index: 999;
  /* width: 84.22%; */
  width: 83.6%;
  height: 0;
  /* padding-bottom: 101%; */
  padding-bottom: 84.225%;
  top: 25%;
  left: 8.2%;
  background: url("../../static/img/login/login.png") no-repeat;
  background-size: 100% 100%;
}

.login .input1 {
  width: 76.82%;
  height: 9.2%;
  position: absolute;
  left: 8%;
  bottom: 44%;
}

.input1 input {
  width: 100%;
  border-style: none;
  height: 100%;
  background-color: rgb(255, 251, 240);
  border-radius: 12px;
  padding-left: 15px;
  outline: none;
  border: 3px solid rgb(215, 154, 4);
  font-size: 17px;
}

.input1 input::placeholder {
  color: rgb(175, 170, 170);
  font-size: 17px;
}

.login .input3 {
  width: 76.82%;
  height: 9.2%;
  position: absolute;
  left: 8%;
  bottom: 28%;
}

.input3 input {
  width: 100%;
  border-style: none;
  height: 100%;
  background-color: rgb(255, 251, 240);
  border-radius: 15px;
  padding-left: 15px;
  outline: none;
  border: 3px solid rgb(215, 154, 4);
  font-size: 17px;
}

.input3 input::placeholder {
  color: rgb(175, 170, 170);
  font-size: 17px;
}

.button3 {
  position: absolute;
  width: 39.09%;
  height: 84%;
  left: 67%;
  top: 19%;
  background: url("../../static/img/login/get-code.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 20px;
  overflow: hidden;
  background-color: none;
  border-style: none;
  font-size: 13px;
  vertical-align: middle;
  color: rgb(255, 255, 255);
}

.button2 {
  position: absolute;
  width: 39.09%;
  height: 84%;
  left: 67%;
  top: 19%;
  background: url("../../static/img/login/get-code1.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 20px;
  overflow: hidden;
  background-color: none;
  border-style: none;
  font-size: 13px;
  vertical-align: middle;
  color: rgb(255, 255, 255);
}

.submit {
  position: absolute;
  width: 40.37%;
  height: 14.65%;
  bottom: 7%;
  left: 30%;
  background: url("../../static/img/login/button1.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 40px;
  background-color: none;
  overflow: hidden;
}

.submit:active {
  background: url("../../static/img/login/button2_press.png") no-repeat;
  background-size: 100% 100%;
}

.PaySucDialog {
  position: absolute;
  z-index: 999;
  width: 80.15625%;
  height: 0;
  padding-bottom: 39.375%;
  top: 35%;
  left: 10%;
  background: url("../../static/img/market/pay_bg.png") no-repeat;
  background-size: 100% 100%;
}

.PayH5Dialog {
  position: absolute;
  z-index: 999;
  width: 80.15625%;
  height: 0;
  padding-bottom: 39.375%;
  top: 35%;
  left: 10%;
  background: url("../../static/img/market/pay_bg1.png") no-repeat;
  background-size: 100% 100%;
}

.okPayButton {
  position: absolute;
  width: 38.99%;
  /* height: 75.31%; */
  height: 0;
  padding-bottom: 12.8667%;
  bottom: 5%;
  left: 30%;
  background: url("../../static/img/market/pay_btn.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 40px;
  background-color: none;
  overflow: hidden;
}

.okPayButton:active {
  background: url("../../static/img/market/pay_btn_press.png") no-repeat;
  background-size: 100% 100%;
}

.ExitDialog {
  position: absolute;
  z-index: 999;
  width: 84.69%;
  height: 0;
  padding-bottom: 60.3143%;
  top: 25%;
  left: 8%;
  background: url("../../static/img/market/exit-bg.png") no-repeat;
  background-size: 100% 100%;
}

.noexit {
  position: absolute;
  width: 37.638%;
  /* height: 18.13%; */
  height: 0;
  padding-bottom: 12.3615%;
  bottom: 25%;
  left: 8%;
  background: url("../../static/img/market/no.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 40px;
  background-color: none;
  overflow: hidden;
}

.yesexit {
  position: absolute;
  width: 37.638%;
  /* height: 18.13%; */
  height: 0;
  padding-bottom: 12.3615%;
  bottom: 25%;
  right: 10%;
  background: url("../../static/img/market/yes.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  user-select: none;
  border-radius: 40px;
  background-color: none;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/market_h5.vue